import { useGetPlayerEventsV1TohQuery } from "../../../core/api/toh-player-events-api"
import PlayerEventsDialog from "../common/PlayerEventsDialog"
import PlayerEventsPage from "../common/PlayerEventsPage"
import { initialQuickLookSettings } from "./TohPlayerEventsConstants"

const TohPlayerEvents = () => (
    <PlayerEventsPage
        useQuery={useGetPlayerEventsV1TohQuery}
        storageKey="toh_quick_look_settings"
        initialSettings={initialQuickLookSettings}
        typeField="eventType"
        typeHeaderName="Event Type"
        DialogComponent={PlayerEventsDialog}
    />
)

export default TohPlayerEvents
